import { NavLink } from 'react-router';
import { cx } from '../lib/cx.ts';
import type { NavSectionKey } from './nav.ts';
import { usePageMeta } from './pageMeta.tsx';
import { useNavSections } from './useNavSections.ts';

/**
 * Tabs across the top of a page for the other pages of its sidebar section
 * (e.g. ส่งข้อความถึงหมวดหมู่ → รายการส่งข้อความ · ตั้งเวลาไว้ · ผลการส่งรายคน · ส่งไม่สำเร็จ).
 * Nothing is rendered for single-page sections.
 */
export function SectionTabs({ section }: { section: NavSectionKey | undefined }) {
  const sections = useNavSections();
  const { setActionsSlot } = usePageMeta();
  const current = sections.find((s) => s.key === section);
  if (!current || current.items.length < 2) return null;
  return (
    <div className="section-bar">
    <nav className="section-tabs" aria-label={current.label}>
      <ul className="section-tabs__list">
        {current.items.map((item) => {
          const Icon = item.icon;
          return (
            <li key={item.key}>
              <NavLink to={item.to} end={item.to === '/'} className={({ isActive }) => cx('section-tabs__tab', isActive && 'is-active')} title={item.description}>
                <Icon size={16} strokeWidth={1.75} aria-hidden="true" />
                <span>{item.label}</span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
      <div className="section-bar__actions" ref={setActionsSlot} />
    </div>
  );
}
